import { Component, OnInit, Input } from "@angular/core";
import { Subscription } from "rxjs";
import { WebCompany } from "src/app/models";
import { CompanyService } from "src/app/services";


@Component({
  selector: "app-login-header",
  templateUrl: "./login-header.component.html",
  styleUrls: ["./login-header.component.scss"]
})
export class LoginHeaderComponent implements OnInit
{
  @Input("icon") icon: any;
  @Input("companyName") companyName: any
  @Input("desc") desc: any;
  @Input("hideBreadcrumb") hideBreadcrumb: boolean = false;
  @Input("hasBgImage") hasBgImage: boolean = false;
  @Input("class") class: any;
  company: WebCompany;
  companySubscription: Subscription;
  displayCompanyName: boolean;
  constructor(
    public companyService: CompanyService,
  ) { }

  ngOnInit()
  {
    this.companySubscription = this.companyService.company.subscribe(e =>
    {
      this.company = e;
      this.displayCompanyName = e.WebDisplayCompanyName;
    });
  }

}